import {
  createContext,
  useContext,
  useRef,
  useState,
  type MutableRefObject,
} from 'react'

type ContextValue = {
  focusSearch?: () => void
  isSearchable: boolean
  searchFocused: boolean
  searchRef?: MutableRefObject<HTMLInputElement | null>
  searchTerm: string
  setSearchFocused: (focused: boolean) => void
  setSearchTerm: (term: string) => void
}

export const SearchContext = createContext<ContextValue>({
  isSearchable: false,
  searchFocused: false,
  searchTerm: '',
  setSearchFocused: () => null,
  setSearchTerm: () => null,
})
SearchContext.displayName = 'Lapidary: SearchContext ← SingleSelect'

export const SearchProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const searchRef = useRef<HTMLInputElement>(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [searchFocused, setSearchFocused] = useState(false)

  const focusSearch = () => {
    setSearchFocused(true)
    setTimeout(() => searchRef.current?.focus(), 0)
  }

  return (
    <SearchContext.Provider
      value={{
        focusSearch,
        isSearchable: true,
        searchFocused,
        searchRef,
        searchTerm,
        setSearchFocused,
        setSearchTerm,
      }}
    >
      {children}
    </SearchContext.Provider>
  )
}
SearchProvider.displayName = 'Lapidary: SearchProvider ← SingleSelect'

export const useSingleSelectSearch = () => useContext(SearchContext)
